export function CreateBrandPageHeader({
  description,
  title,
}: {
  description: string;
  title: string;
}) {
  return (
    <div className="flex flex-col items-center mb-6">
      <h1 className="text-display-md mb-3">
        <p className="font-semibold text-[30px] text-text-primary">{title}</p>
      </h1>
      <p className="text-body-md text-[16px] text-text-secondary">
        {description}
      </p>
    </div>
  );
}
